// extracted by mini-css-extract-plugin
export default {"error":"UserAsignations_error__evDvS","searchForm":"UserAsignations_searchForm__+Ekz+","icon":"UserAsignations_icon__sGtuP"};